import { FormCreator } from '../../components';
import { NON_ADMIN_ROLES, NON_MANAGER_ROLES } from '../../utils/constants';

export const DEVICES_REDUCER_KEY = 'devices';

export const ADD_DEVICE_IDS = {
  IMEI: 'imei',
  EXISTING_FOUND: 'existingFound',
  DEVICE_DETAILS: 'deviceDetails',
  OWNER_DETAILS: 'ownerDetails',
  THANKYOU: 'thankyou',
  AGENT_ID: 'agentSelection'
};

export const ADD_DEVICE_FLOW_STEPS = [
  {
    id: ADD_DEVICE_IDS.IMEI,
    title: 'add.device.flow.step.imei',
    defaultTitle: 'Enter Device IMEI',
    showStage: true,
    showNext: true,
    showPrevious: false,
    showSkip: false,
  },
  {
    id: ADD_DEVICE_IDS.EXISTING_FOUND,
    title: 'add.device.flow.step.continue.existing',
    defaultTitle: 'Device Already Found',
    showStage: false,
    showNext: false,
    showPrevious: false,
    showSkip: false,
  },
  {
    id: ADD_DEVICE_IDS.DEVICE_DETAILS,
    title: 'add.device.flow.step.device.details',
    defaultTitle: 'Enter Device Details',
    showStage: true,
    showNext: true,
    showPrevious: true,
    showSkip: false,
  },
  {
    id: ADD_DEVICE_IDS.AGENT_ID,
    title: 'add.device.flow.step.agent.details',
    defaultTitle: 'Enter Agent Details',
    showStage: false,
    showNext: true,
    showPrevious: true,
    showSkip: false,
  },
  {
    id: ADD_DEVICE_IDS.THANKYOU,
    title: 'add.device.flow.step.thankyou',
    defaultTitle: 'Done',
    showStage: true,
    showNext: false,
    showPrevious: false,
    showSkip: false,
  },
];

const { Schema, TYPES } = FormCreator;

export const IMEI_FORM_SCHEMA = new Schema(
  TYPES.NUMBER,
  'imei',
  'IMEI Number',
  undefined,
  { fullWidth: true },
  [],
  NON_MANAGER_ROLES,
);

export const DEVICE_NAME_FORM_SCHEMA = new Schema(TYPES.TEXT, 'name', 'Device Name', undefined, { required: true, fullWidth: true });
export const DEVICE_MODEL_FORM_SCHEMA = new Schema(
  TYPES.DROPDOWN,
  'deviceModel',
  'Device Model',
  undefined,
  { required: true, fullWidth: true },
  [],
  NON_MANAGER_ROLES,
);

export const IMSI_FORM_SCHEMA = new Schema(
  TYPES.TEXT,
  'imsi',
  'IMSI Number',
  undefined,
  { fullWidth: true },
  [],
  NON_MANAGER_ROLES,
);

export const MOBILE_NUMBER_FORM_SCHEMA = new Schema(TYPES.TEXT, 'mobileNumber', 'Mobile Number', undefined, { required: false, fullWidth: true });

export const DEVICE_AGENT_FORM_SCHEMA = new Schema(
  TYPES.DROPDOWN,
  'agentId',
  'Set Agent',
  undefined,
  { required: true, fullWidth: true },
  NON_ADMIN_ROLES,
  NON_ADMIN_ROLES,
);

export const DEVICE_FORM_VALIDATION_SCHEMA = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 32,
    },
  },
  imei: {
    presence: { allowEmpty: false, message: 'is required' },
  },
  imsi: {
    presence: { allowEmpty: false, message: 'is required' },
  },
  deviceModel: {
    presence: { allowEmpty: false, message: 'is required' },
  },
  // mobileNumber: {
  //   presence: { allowEmpty: true, message: 'is required' },
  // }
};

